/**
 *
 * SignIn
 *
 */

import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../../images/shiphawk-logo-navy-retina.png';
import styles from '../styles.module.css';
import SignInFlow from './components/SignInFlow.js';

function SignIn() {
  const location = useLocation();
  const error = new URLSearchParams(location.search).get('error') || '';

  return (
    <div className={styles.container}>
      <Link to="/sign-in">
        <img data-testid="logoLink" className={styles.logo} alt="" src={logo} />
      </Link>

      <SignInFlow initialError={error} />
    </div>
  );
}

export default SignIn;
